export const bismillahWhite =
	"https://storage.googleapis.com/public_viteslink_storage/images/invitation01/bismillah%20white.svg";
export const bismillah = "https://storage.googleapis.com/public_viteslink_storage/images/invitation01/bismillah.svg";
export const LANG_AR = "AR";
export const LANG_EN = "EN";
export const RTL = "rtl";
export const LTR = "ltr";
